import type { APIResponse } from '../client/api-client';
import {
  AutomaticStockCount,
  AutomaticStockCountStatus,
  AutomaticStockCountUpdate,
  ProductionUnit,
  SuccessResponse,
} from '../types/types';

type APICall = (
  path: string,
  method: string,
  headers: Headers,
  body?: BodyInit | null,
) => Promise<APIResponse>;

export function automaticStockCountURL(
  automaticStockCount: AutomaticStockCount,
): string {
  const params = new URLSearchParams({
    automatic_stock_count_id: automaticStockCount.id,
    production_unit_id: automaticStockCount.production_unit_id,
  });
  return `/stock-count?${params.toString()}`;
}

export function productionUnitNames(
  productionUnits: ProductionUnit[],
): Map<string, string> {
  return new Map(
    productionUnits.map(productionUnit => [
      productionUnit.id,
      productionUnit.name,
    ]),
  );
}

export function findProductionUnit(
  productionUnits: ProductionUnit[],
  productionUnitID: string,
): ProductionUnit | undefined {
  return productionUnits.find(
    productionUnit => productionUnit.id === productionUnitID,
  );
}

export function stockCountSuccessURL(
  automaticStockCountID: string | null,
): '/' | null {
  return automaticStockCountID ? '/' : null;
}

export async function invalidateAutomaticStockCount(
  automaticStockCountID: string,
  apiCall: APICall,
): Promise<boolean> {
  const body: AutomaticStockCountUpdate = {
    status: AutomaticStockCountStatus.Invalid,
  };
  const result = await apiCall(
    `/stock/automatic-count/${automaticStockCountID}`,
    'PUT',
    new Headers(),
    JSON.stringify(body),
  );
  const response = result.body as SuccessResponse | undefined;
  return result.statusCode === 200 && response?.success === true;
}
